import styled from 'styled-components';
import { Layout as LayoutDefault } from 'antd';

import { NAVBAR_HEIGHT } from '../../constants/ui';

import * as Colors from '../../attrs/colors';
import MQ from '../../attrs/mq';

export const Layout = styled(LayoutDefault)`
  background: ${Colors.WHITE};
  min-height: calc(100vh - ${NAVBAR_HEIGHT}px);
`;

export const Container = styled.div`
  max-width: 1170px;
  margin: 0 auto;
  padding: 0 1rem;

  ${MQ.sm`
    padding: 0 2rem;
  `}

  ${MQ.md`
    padding: 0 3rem;
  `}
`;
